import React from "react";
import { useNavigate } from "react-router";
import Button from "../../../components/button";
import DocumentPage from "../../../components/document-page";
import styles from '../styles.module.css';
import { HelpLink } from "../../../common/help";

function OfferPage() {
  const navigation = useNavigate();

  const handleClickPrevPage = () => {
    navigation('/account');
  }

  return (
       <DocumentPage variant="scrollable" className="offer-container">
        <h1>Оферта на обслуживание "OpenWay"</h1>
        <hr/>
        <div className="offer-header">
            <p>
                Настоящая оферта является предложением "OpenWay" заключить договор на предоставление услуг Шифрованного канала
            </p>    
        </div>

        <div className="section">
            <h2>1. Общие положения</h2>
            <p>Настоящая оферта (далее – "Оферта") является предложением “OpenWay” (далее – "Исполнитель"), заключить договор на предоставление услуг Шифрованного канала (далее – "Услуги") с физическими и юридическими лицами (далее – "Заказчик"), которые принимают условия данной Оферты.</p>
        </div>

        <div className="section">
            <h2>2. Предмет Оферты</h2>
            <p>Исполнитель обязуется предоставить Заказчику услуги по доступу к шифрованному каналу, который обеспечивает безопасное и анонимное соединение с интернетом, защиту данных и конфиденциальность информации.</p>
        </div>

        <div className="section">
            <h2>3. Услуги</h2>
            <p><strong>3.1.</strong> В рамках данной Оферты Исполнитель предоставляет следующие услуги:</p>
            <ul>
                <li>Доступ к серверу зашифрованного канала с высокой степенью защиты.</li>
                <li>Защита данных Заказчика с использованием современных протоколов шифрования.</li>
                <li>Поддержка различных платформ (Windows, macOS, Android, iOS и др.).</li>
                <li>Техническая поддержка.</li>
                <li>Обновления программного обеспечения и сервиса.</li>
            </ul>
        </div>

        <div className="section">
            <h2>4. Права и обязанности сторон</h2>
            
            <h3>4.1. Обязанности Исполнителя:</h3>
            <ul>
                <li>Обеспечить стабильный доступ к шифрованному каналу.</li>
                <li>Оказывать техническую поддержку Заказчику.</li>
                <li>Информировать Заказчика о любых изменениях в работе сервиса.</li>
            </ul>

            <h3>4.2. Обязанности Заказчика:</h3>
            <ul>
                <li>Своевременно оплачивать услуги.</li>
                <li>Не передавать свои учетные данные третьим лицам.</li>
                <li>Не использовать сервис в целях, нарушающих законодательство Российской Федерации, включая, но не ограничиваясь, противоправной деятельностью, распространением запрещённой информации, мошенничеством и иными незаконными действиями.</li>
            </ul>
        </div>

        <div className="section">
            <h2>5. Стоимость услуг и порядок расчетов</h2>
            <p><strong>5.1.</strong> Стоимость услуг определяется в соответствии с выбранным тарифным планом:</p>
            
            <div className="price-list">
                <div className="price-item">
                    <p>3 устройства - 249 рублей в месяц</p>
                </div>
                <div className="price-item">
                    <p>5 устройств - 349 рублей в месяц</p>
                </div>
                <div className="price-item">
                    <p>10 устройств - 549 рублей в месяц</p>
                </div>
            </div>
            
            <p>• Оплата производится онлайн в срок не позднее 3-х дней с момента выставления счета.</p>
        </div>

        <div className="section">
            <h2>6. Ответственность сторон</h2>
            <p><strong>6.1.</strong> Исполнитель не несет ответственности за убытки, возникшие в результате использования или невозможности использования услуг, если они были вызваны обстоятельствами непреодолимой силы или действиями третьих лиц.</p>
            <p><strong>6.2</strong> Заказчик самостоятельно несёт ответственность за все действия, совершаемые с использованием предоставленного доступа к шифрованному каналу. Исполнитель не несет ответственности за любые последствия использования сервиса Заказчиком.</p>
        </div>

        <div className="section">
            <h2>7. Срок действия Оферты</h2>
            <p><strong>7.1.</strong> Настоящая Оферта вступает в силу с момента ее акцепта Заказчиком и действует до момента расторжения договора.</p>
        </div>

        <div className="section">
            <h2>8. Заключительные положения</h2>
            <p><strong>8.1.</strong> Акцепт настоящей Оферты является подтверждением того, что Заказчик ознакомлен с условиями предоставления услуг и принимает их. Все споры, возникающие в связи с исполнением данной Оферты, будут разрешаться в соответствии с действующим законодательством Российской Федерации.</p>
        </div>

        <div className="company-info">
            <h2>Контактная информация:</h2>
        </div>

        <div className="acceptance-note">
            <p>Подписываясь на услуги Исполнителя, Заказчик подтверждает свое согласие с условиями настоящей Оферты.</p>
        </div>

        <div className="contact-info">
            <h3>По вопросам обращайтесь:</h3>
            <p><strong>Telegram:</strong> <a href={HelpLink} target="_blank" rel="noreferrer">{HelpLink}</a></p>
        </div>

        <div className="footer-note">
            <p>© 2026 OpenWay. Все права защищены.</p>
        </div>
        <Button className={styles.btn} label="Назад" onClick={() => handleClickPrevPage()}></Button>
    </DocumentPage>
  );
}

export default OfferPage;